import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-north-carolina-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./north-carolina-state-form.component.html",
  styleUrl: "./north-carolina-state-form.component.scss",
})
export class NorthCarolinaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
